module.exports = __webpack_public_path__ + "media/zelda.49f51d95.wav";